import { useEffect, useState } from 'react';

export enum ScreenSize {
  XXS = 'XXS',
  XS = 'XS',
  SM = 'SM',
  MD = 'MD',
  L = 'L',
  XL = 'XL',
  XXL = 'XXL',
  XXSAndOver = 'XXSAndOver',
  XSAndOver = 'XSAndOver',
  SMAndOver = 'SMAndOver',
  MDAndOver = 'MDAndOver',
  LAndOver = 'LAndOver',
  XLAndOver = 'XLAndOver',
  XXLAndOver = 'XXLAndOver',
  XXSAndUnder = 'XXSAndUnder',
  XSAndUnder = 'XSAndUnder',
  SMAndUnder = 'SMAndUnder',
  MDAndUnder = 'MDAndUnder',
  LAndUnder = 'LAndUnder',
  XLAndUnder = 'XLAndUnder',
  XXLAndUnder = 'XXLAndUnder',
}

const ScreenSizeMediaQueries: Record<ScreenSize, string> = {
  [ScreenSize.XXS]: 'only screen and (max-width: 375px)',
  [ScreenSize.XS]: 'only screen and (min-width: 376px) and (max-width: 479px)',
  [ScreenSize.SM]: 'only screen and (min-width: 480px) and (max-width: 767px)',
  [ScreenSize.MD]: 'only screen and (min-width: 768px) and (max-width: 1023px)',
  [ScreenSize.L]: 'only screen and (min-width: 1024px) and (max-width: 1279px)',
  [ScreenSize.XL]:
    'only screen and (min-width: 1280px) and (max-width: 1439px)',
  [ScreenSize.XXL]: 'only screen and (min-width: 1440px)',
  [ScreenSize.XXSAndOver]: 'only screen and (min-width: 0px)', // always true
  [ScreenSize.XSAndOver]: 'only screen and (min-width: 376px)',
  [ScreenSize.SMAndOver]: 'only screen and (min-width: 480px)',
  [ScreenSize.MDAndOver]: 'only screen and (min-width: 768px)',
  [ScreenSize.LAndOver]: 'only screen and (min-width: 1024px)',
  [ScreenSize.XLAndOver]: 'only screen and (min-width: 1280px)',
  [ScreenSize.XXLAndOver]: 'only screen and (min-width: 1440px)',
  [ScreenSize.XXSAndUnder]: 'only screen and (max-width: 375px)',
  [ScreenSize.XSAndUnder]: 'only screen and (max-width: 479px)',
  [ScreenSize.SMAndUnder]: 'only screen and (max-width: 767px)',
  [ScreenSize.MDAndUnder]: 'only screen and (max-width: 1023px)',
  [ScreenSize.LAndUnder]: 'only screen and (max-width: 1279px)',
  [ScreenSize.XLAndUnder]: 'only screen and (max-width: 1439px)',
  [ScreenSize.XXLAndUnder]: 'only screen and (min-width: 0px)', // always true
};

const getMatches = (query: string) => window.matchMedia(query).matches;

function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(getMatches(query));

  useEffect(() => {
    const handleChange = () => {
      setMatches(getMatches(query));
    };
    const matchMedia = window.matchMedia(query);
    handleChange();
    matchMedia.addEventListener('change', handleChange);
    return () => {
      matchMedia.removeEventListener('change', handleChange);
    };
  }, [query]);

  return matches;
}

export function useIsScreenSize(screenSize: ScreenSize): boolean {
  return useMediaQuery(ScreenSizeMediaQueries[screenSize]);
}
